import { Column } from '@tempmee/react';
import { IDraftJobPostEntity } from '~/domain/PermanentJobs';
import { Colors } from '~/themes/colors';
import {
  formatBenefits,
  formatExpectedDays,
  formatPayRange,
  formatPayTitle,
} from '../utils/formatters';
import { InfoSection } from './InfoSection';
import { LabelValueDisplay } from './LabelValueDisplay';

interface IScheduleAndPayReviewProps {
  jobPosting: IDraftJobPostEntity;
  onEditClick: () => void;
}

export const ScheduleAndPayReview = ({ jobPosting, onEditClick }: IScheduleAndPayReviewProps) => {
  return (
    <InfoSection
      title="Schedule & Pay"
      titleColor="neutral_600"
      titleFontSize={24}
      rightActionIcon="edit-pencil"
      onRightActionPress={onEditClick}
      containerStyle={{ backgroundColor: Colors.white, paddingInline: 40 }}
    >
      <Column gap={4}>
        <LabelValueDisplay label="Schedule Type" value={jobPosting.scheduleType || ''} />
        <LabelValueDisplay
          label="Expected Days"
          value={formatExpectedDays(jobPosting.expectedDays || [])}
        />
        <LabelValueDisplay label="Pay Type" value={jobPosting.payType} />
        <LabelValueDisplay
          label={formatPayTitle(jobPosting.minRate, jobPosting.maxRate)}
          value={formatPayRange(jobPosting.minRate, jobPosting.maxRate, jobPosting.payType)}
        />
        <LabelValueDisplay label="Benefits" value={formatBenefits(jobPosting.benefits || [])} />
        {jobPosting.benefitsOther && (
          <LabelValueDisplay label="Other Benefits" value={jobPosting.benefitsOther} />
        )}
      </Column>
    </InfoSection>
  );
};
